import React from "react";
import ViewPaymentDetails from "../component/PaymentDetails/ViewPaymentDetails";

const PaymentDetails = () => {
  return (
    <>
      <ViewPaymentDetails />
    </>
  );
};

export default PaymentDetails;
